export const EXTENSION_ID = 'najhcokfanmgakdjpddfncognnhoggeg'
export const CH_PLUGIN_VERSION = '1.0.0'
